/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as RegisterRouteImport } from './routes/register'
import { Route as LoginRouteImport } from './routes/login'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthenticatedWorkOrdersRouteImport } from './routes/_authenticated/work-orders'
import { Route as AuthenticatedUsersRouteImport } from './routes/_authenticated/users'
import { Route as AuthenticatedUserManagementRouteImport } from './routes/_authenticated/user-management'
import { Route as AuthenticatedTrainingManagementRouteImport } from './routes/_authenticated/training-management'
import { Route as AuthenticatedTrainingRouteImport } from './routes/_authenticated/training'
import { Route as AuthenticatedTicketsRouteImport } from './routes/_authenticated/tickets'
import { Route as AuthenticatedTeamsRouteImport } from './routes/_authenticated/teams'
import { Route as AuthenticatedSupplierCertificatesRouteImport } from './routes/_authenticated/supplier-certificates'
import { Route as AuthenticatedShiftManagementRouteImport } from './routes/_authenticated/shift-management'
import { Route as AuthenticatedSettingsRouteImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedReportsRouteImport } from './routes/_authenticated/reports'
import { Route as AuthenticatedReliabilityRouteImport } from './routes/_authenticated/reliability'
import { Route as AuthenticatedPurchaseRequestsRouteImport } from './routes/_authenticated/purchase-requests'
import { Route as AuthenticatedProfileRouteImport } from './routes/_authenticated/profile'
import { Route as AuthenticatedPreventiveMaintenanceRouteImport } from './routes/_authenticated/preventive-maintenance'
import { Route as AuthenticatedPartsManagementRouteImport } from './routes/_authenticated/parts-management'
import { Route as AuthenticatedParameterManagementRouteImport } from './routes/_authenticated/parameter-management'
import { Route as AuthenticatedNotificationsRouteImport } from './routes/_authenticated/notifications'
import { Route as AuthenticatedMyWorkRouteImport } from './routes/_authenticated/my-work'
import { Route as AuthenticatedKnowledgeCenterRouteImport } from './routes/_authenticated/knowledge-center'
import { Route as AuthenticatedIntegrationsRouteImport } from './routes/_authenticated/integrations'
import { Route as AuthenticatedHomeRouteImport } from './routes/_authenticated/home'
import { Route as AuthenticatedGamificationRouteImport } from './routes/_authenticated/gamification'
import { Route as AuthenticatedFilesRouteImport } from './routes/_authenticated/files'
import { Route as AuthenticatedChecklistManagementRouteImport } from './routes/_authenticated/checklist-management'
import { Route as AuthenticatedCertificatesRouteImport } from './routes/_authenticated/certificates'
import { Route as AuthenticatedCalibrationManagementRouteImport } from './routes/_authenticated/calibration-management'
import { Route as AuthenticatedAssetsRouteImport } from './routes/_authenticated/assets'
import { Route as AuthenticatedAssetStatusesRouteImport } from './routes/_authenticated/asset-statuses'
import { Route as AuthenticatedAssetStatusEventsRouteImport } from './routes/_authenticated/asset-status-events'
import { Route as AuthenticatedAssetManagementRouteImport } from './routes/_authenticated/asset-management'
import { Route as AuthenticatedApiDocsRouteImport } from './routes/_authenticated/api-docs'
import { Route as AuthenticatedAnalyticsRouteImport } from './routes/_authenticated/analytics'
import { Route as AuthenticatedWorkOrdersIndexRouteImport } from './routes/_authenticated/work-orders/index'
import { Route as AuthenticatedReportsIndexRouteImport } from './routes/_authenticated/reports/index'
import { Route as AuthenticatedPartsManagementIndexRouteImport } from './routes/_authenticated/parts-management/index'
import { Route as AuthenticatedComplianceIndexRouteImport } from './routes/_authenticated/compliance/index'
import { Route as AuthenticatedAnalyticsIndexRouteImport } from './routes/_authenticated/analytics/index'
import { Route as AuthenticatedAdminIndexRouteImport } from './routes/_authenticated/admin/index'
import { Route as AuthenticatedWorkOrdersWorkOrderIdRouteImport } from './routes/_authenticated/work-orders/$workOrderId'
import { Route as AuthenticatedUserUserIdRouteImport } from './routes/_authenticated/user.$userId'
import { Route as AuthenticatedReportsTemplatesRouteImport } from './routes/_authenticated/reports/templates'
import { Route as AuthenticatedReportsScheduledRouteImport } from './routes/_authenticated/reports/scheduled'
import { Route as AuthenticatedReportsHistoryRouteImport } from './routes/_authenticated/reports/history'
import { Route as AuthenticatedReportsDashboardsRouteImport } from './routes/_authenticated/reports/dashboards'
import { Route as AuthenticatedReportsBenchmarksRouteImport } from './routes/_authenticated/reports/benchmarks'
import { Route as AuthenticatedReportsAiBuilderRouteImport } from './routes/_authenticated/reports/ai-builder'
import { Route as AuthenticatedPartsManagementSuppliersRouteImport } from './routes/_authenticated/parts-management/suppliers'
import { Route as AuthenticatedPartsManagementCategoriesRouteImport } from './routes/_authenticated/parts-management/categories'
import { Route as AuthenticatedIntegrationsWebhooksRouteImport } from './routes/_authenticated/integrations.webhooks'
import { Route as AuthenticatedIntegrationsApiRouteImport } from './routes/_authenticated/integrations.api'
import { Route as AuthenticatedComplianceSafetyRouteImport } from './routes/_authenticated/compliance/safety'
import { Route as AuthenticatedComplianceRegulationsRouteImport } from './routes/_authenticated/compliance/regulations'
import { Route as AuthenticatedComplianceLotoPermitsRouteImport } from './routes/_authenticated/compliance/loto-permits'
import { Route as AuthenticatedComplianceDashboardRouteImport } from './routes/_authenticated/compliance/dashboard'
import { Route as AuthenticatedComplianceCertificatesRouteImport } from './routes/_authenticated/compliance/certificates'
import { Route as AuthenticatedComplianceAuditLogRouteImport } from './routes/_authenticated/compliance/audit-log'
import { Route as AuthenticatedChecklistManagementTemplatesRouteImport } from './routes/_authenticated/checklist-management/templates'
import { Route as AuthenticatedChecklistManagementInstancesRouteImport } from './routes/_authenticated/checklist-management/instances'
import { Route as AuthenticatedAssetAssetIdRouteImport } from './routes/_authenticated/asset.$assetId'
import { Route as AuthenticatedAnalyticsReportsRouteImport } from './routes/_authenticated/analytics/reports'
import { Route as AuthenticatedAnalyticsPersonnelPerformanceRouteImport } from './routes/_authenticated/analytics/personnel-performance'
import { Route as AuthenticatedAnalyticsPartsStockRouteImport } from './routes/_authenticated/analytics/parts-stock'
import { Route as AuthenticatedAnalyticsInsightsRouteImport } from './routes/_authenticated/analytics/insights'
import { Route as AuthenticatedAnalyticsCustomDashboardRouteImport } from './routes/_authenticated/analytics/custom-dashboard'
import { Route as AuthenticatedAnalyticsAssetStatusSegmentsRouteImport } from './routes/_authenticated/analytics/asset-status-segments'
import { Route as AuthenticatedIntegrationsWebhooksIndexRouteImport } from './routes/_authenticated/integrations.webhooks.index'
import { Route as AuthenticatedAdminWorkflowsIndexRouteImport } from './routes/_authenticated/admin/workflows/index'
import { Route as AuthenticatedIntegrationsWebhooksCreateRouteImport } from './routes/_authenticated/integrations.webhooks.create'
import { Route as AuthenticatedIntegrationsWebhooksIdRouteImport } from './routes/_authenticated/integrations.webhooks.$id'
import { Route as AuthenticatedAdminWorkflowsWorkflowIdRouteImport } from './routes/_authenticated/admin/workflows/$workflowId'
import { Route as AuthenticatedIntegrationsWebhooksIdEditRouteImport } from './routes/_authenticated/integrations.webhooks.$id.edit'

const RegisterRoute = RegisterRouteImport.update({
  id: '/register',
  path: '/register',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedWorkOrdersRoute = AuthenticatedWorkOrdersRouteImport.update({
  id: '/work-orders',
  path: '/work-orders',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUsersRoute = AuthenticatedUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedUserManagementRoute =
  AuthenticatedUserManagementRouteImport.update({
    id: '/user-management',
    path: '/user-management',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTrainingManagementRoute =
  AuthenticatedTrainingManagementRouteImport.update({
    id: '/training-management',
    path: '/training-management',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedTrainingRoute = AuthenticatedTrainingRouteImport.update({
  id: '/training',
  path: '/training',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTicketsRoute = AuthenticatedTicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedTeamsRoute = AuthenticatedTeamsRouteImport.update({
  id: '/teams',
  path: '/teams',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedSupplierCertificatesRoute =
  AuthenticatedSupplierCertificatesRouteImport.update({
    id: '/supplier-certificates',
    path: '/supplier-certificates',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedShiftManagementRoute =
  AuthenticatedShiftManagementRouteImport.update({
    id: '/shift-management',
    path: '/shift-management',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedSettingsRoute = AuthenticatedSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReportsRoute = AuthenticatedReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReliabilityRoute =
  AuthenticatedReliabilityRouteImport.update({
    id: '/reliability',
    path: '/reliability',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPurchaseRequestsRoute =
  AuthenticatedPurchaseRequestsRouteImport.update({
    id: '/purchase-requests',
    path: '/purchase-requests',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedProfileRoute = AuthenticatedProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedPreventiveMaintenanceRoute =
  AuthenticatedPreventiveMaintenanceRouteImport.update({
    id: '/preventive-maintenance',
    path: '/preventive-maintenance',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedPartsManagementRoute =
  AuthenticatedPartsManagementRouteImport.update({
    id: '/parts-management',
    path: '/parts-management',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedParameterManagementRoute =
  AuthenticatedParameterManagementRouteImport.update({
    id: '/parameter-management',
    path: '/parameter-management',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedNotificationsRoute =
  AuthenticatedNotificationsRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedMyWorkRoute = AuthenticatedMyWorkRouteImport.update({
  id: '/my-work',
  path: '/my-work',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedKnowledgeCenterRoute =
  AuthenticatedKnowledgeCenterRouteImport.update({
    id: '/knowledge-center',
    path: '/knowledge-center',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIntegrationsRoute =
  AuthenticatedIntegrationsRouteImport.update({
    id: '/integrations',
    path: '/integrations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedHomeRoute = AuthenticatedHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedGamificationRoute =
  AuthenticatedGamificationRouteImport.update({
    id: '/gamification',
    path: '/gamification',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedFilesRoute = AuthenticatedFilesRouteImport.update({
  id: '/files',
  path: '/files',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedChecklistManagementRoute =
  AuthenticatedChecklistManagementRouteImport.update({
    id: '/checklist-management',
    path: '/checklist-management',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCertificatesRoute =
  AuthenticatedCertificatesRouteImport.update({
    id: '/certificates',
    path: '/certificates',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCalibrationManagementRoute =
  AuthenticatedCalibrationManagementRouteImport.update({
    id: '/calibration-management',
    path: '/calibration-management',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAssetsRoute = AuthenticatedAssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAssetStatusesRoute =
  AuthenticatedAssetStatusesRouteImport.update({
    id: '/asset-statuses',
    path: '/asset-statuses',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAssetStatusEventsRoute =
  AuthenticatedAssetStatusEventsRouteImport.update({
    id: '/asset-status-events',
    path: '/asset-status-events',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAssetManagementRoute =
  AuthenticatedAssetManagementRouteImport.update({
    id: '/asset-management',
    path: '/asset-management',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedApiDocsRoute = AuthenticatedApiDocsRouteImport.update({
  id: '/api-docs',
  path: '/api-docs',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedAnalyticsRoute = AuthenticatedAnalyticsRouteImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedWorkOrdersIndexRoute =
  AuthenticatedWorkOrdersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedWorkOrdersRoute,
  } as any)
const AuthenticatedReportsIndexRoute =
  AuthenticatedReportsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedPartsManagementIndexRoute =
  AuthenticatedPartsManagementIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedPartsManagementRoute,
  } as any)
const AuthenticatedComplianceIndexRoute =
  AuthenticatedComplianceIndexRouteImport.update({
    id: '/compliance/',
    path: '/compliance/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAnalyticsIndexRoute =
  AuthenticatedAnalyticsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedAnalyticsRoute,
  } as any)
const AuthenticatedAdminIndexRoute = AuthenticatedAdminIndexRouteImport.update({
  id: '/admin/',
  path: '/admin/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedWorkOrdersWorkOrderIdRoute =
  AuthenticatedWorkOrdersWorkOrderIdRouteImport.update({
    id: '/$workOrderId',
    path: '/$workOrderId',
    getParentRoute: () => AuthenticatedWorkOrdersRoute,
  } as any)
const AuthenticatedUserUserIdRoute = AuthenticatedUserUserIdRouteImport.update({
  id: '/user/$userId',
  path: '/user/$userId',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedReportsTemplatesRoute =
  AuthenticatedReportsTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsScheduledRoute =
  AuthenticatedReportsScheduledRouteImport.update({
    id: '/scheduled',
    path: '/scheduled',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsHistoryRoute =
  AuthenticatedReportsHistoryRouteImport.update({
    id: '/history',
    path: '/history',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsDashboardsRoute =
  AuthenticatedReportsDashboardsRouteImport.update({
    id: '/dashboards',
    path: '/dashboards',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsBenchmarksRoute =
  AuthenticatedReportsBenchmarksRouteImport.update({
    id: '/benchmarks',
    path: '/benchmarks',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedReportsAiBuilderRoute =
  AuthenticatedReportsAiBuilderRouteImport.update({
    id: '/ai-builder',
    path: '/ai-builder',
    getParentRoute: () => AuthenticatedReportsRoute,
  } as any)
const AuthenticatedPartsManagementSuppliersRoute =
  AuthenticatedPartsManagementSuppliersRouteImport.update({
    id: '/suppliers',
    path: '/suppliers',
    getParentRoute: () => AuthenticatedPartsManagementRoute,
  } as any)
const AuthenticatedPartsManagementCategoriesRoute =
  AuthenticatedPartsManagementCategoriesRouteImport.update({
    id: '/categories',
    path: '/categories',
    getParentRoute: () => AuthenticatedPartsManagementRoute,
  } as any)
const AuthenticatedIntegrationsWebhooksRoute =
  AuthenticatedIntegrationsWebhooksRouteImport.update({
    id: '/webhooks',
    path: '/webhooks',
    getParentRoute: () => AuthenticatedIntegrationsRoute,
  } as any)
const AuthenticatedIntegrationsApiRoute =
  AuthenticatedIntegrationsApiRouteImport.update({
    id: '/api',
    path: '/api',
    getParentRoute: () => AuthenticatedIntegrationsRoute,
  } as any)
const AuthenticatedComplianceSafetyRoute =
  AuthenticatedComplianceSafetyRouteImport.update({
    id: '/compliance/safety',
    path: '/compliance/safety',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedComplianceRegulationsRoute =
  AuthenticatedComplianceRegulationsRouteImport.update({
    id: '/compliance/regulations',
    path: '/compliance/regulations',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedComplianceLotoPermitsRoute =
  AuthenticatedComplianceLotoPermitsRouteImport.update({
    id: '/compliance/loto-permits',
    path: '/compliance/loto-permits',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedComplianceDashboardRoute =
  AuthenticatedComplianceDashboardRouteImport.update({
    id: '/compliance/dashboard',
    path: '/compliance/dashboard',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedComplianceCertificatesRoute =
  AuthenticatedComplianceCertificatesRouteImport.update({
    id: '/compliance/certificates',
    path: '/compliance/certificates',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedComplianceAuditLogRoute =
  AuthenticatedComplianceAuditLogRouteImport.update({
    id: '/compliance/audit-log',
    path: '/compliance/audit-log',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedChecklistManagementTemplatesRoute =
  AuthenticatedChecklistManagementTemplatesRouteImport.update({
    id: '/templates',
    path: '/templates',
    getParentRoute: () => AuthenticatedChecklistManagementRoute,
  } as any)
const AuthenticatedChecklistManagementInstancesRoute =
  AuthenticatedChecklistManagementInstancesRouteImport.update({
    id: '/instances',
    path: '/instances',
    getParentRoute: () => AuthenticatedChecklistManagementRoute,
  } as any)
const AuthenticatedAssetAssetIdRoute =
  AuthenticatedAssetAssetIdRouteImport.update({
    id: '/asset/$assetId',
    path: '/asset/$assetId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedAnalyticsReportsRoute =
  AuthenticatedAnalyticsReportsRouteImport.update({
    id: '/reports',
    path: '/reports',
    getParentRoute: () => AuthenticatedAnalyticsRoute,
  } as any)
const AuthenticatedAnalyticsPersonnelPerformanceRoute =
  AuthenticatedAnalyticsPersonnelPerformanceRouteImport.update({
    id: '/personnel-performance',
    path: '/personnel-performance',
    getParentRoute: () => AuthenticatedAnalyticsRoute,
  } as any)
const AuthenticatedAnalyticsPartsStockRoute =
  AuthenticatedAnalyticsPartsStockRouteImport.update({
    id: '/parts-stock',
    path: '/parts-stock',
    getParentRoute: () => AuthenticatedAnalyticsRoute,
  } as any)
const AuthenticatedAnalyticsInsightsRoute =
  AuthenticatedAnalyticsInsightsRouteImport.update({
    id: '/insights',
    path: '/insights',
    getParentRoute: () => AuthenticatedAnalyticsRoute,
  } as any)
const AuthenticatedAnalyticsCustomDashboardRoute =
  AuthenticatedAnalyticsCustomDashboardRouteImport.update({
    id: '/custom-dashboard',
    path: '/custom-dashboard',
    getParentRoute: () => AuthenticatedAnalyticsRoute,
  } as any)
const AuthenticatedAnalyticsAssetStatusSegmentsRoute =
  AuthenticatedAnalyticsAssetStatusSegmentsRouteImport.update({
    id: '/asset-status-segments',
    path: '/asset-status-segments',
    getParentRoute: () => AuthenticatedAnalyticsRoute,
  } as any)
const AuthenticatedIntegrationsWebhooksIndexRoute =
  AuthenticatedIntegrationsWebhooksIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedIntegrationsWebhooksRoute,
  } as any)
const AuthenticatedAdminWorkflowsIndexRoute =
  AuthenticatedAdminWorkflowsIndexRouteImport.update({
    id: '/admin/workflows/',
    path: '/admin/workflows/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIntegrationsWebhooksCreateRoute =
  AuthenticatedIntegrationsWebhooksCreateRouteImport.update({
    id: '/create',
    path: '/create',
    getParentRoute: () => AuthenticatedIntegrationsWebhooksRoute,
  } as any)
const AuthenticatedIntegrationsWebhooksIdRoute =
  AuthenticatedIntegrationsWebhooksIdRouteImport.update({
    id: '/$id',
    path: '/$id',
    getParentRoute: () => AuthenticatedIntegrationsWebhooksRoute,
  } as any)
const AuthenticatedAdminWorkflowsWorkflowIdRoute =
  AuthenticatedAdminWorkflowsWorkflowIdRouteImport.update({
    id: '/admin/workflows/$workflowId',
    path: '/admin/workflows/$workflowId',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedIntegrationsWebhooksIdEditRoute =
  AuthenticatedIntegrationsWebhooksIdEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => AuthenticatedIntegrationsWebhooksIdRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/analytics': typeof AuthenticatedAnalyticsRouteWithChildren
  '/api-docs': typeof AuthenticatedApiDocsRoute
  '/asset-management': typeof AuthenticatedAssetManagementRoute
  '/asset-status-events': typeof AuthenticatedAssetStatusEventsRoute
  '/asset-statuses': typeof AuthenticatedAssetStatusesRoute
  '/assets': typeof AuthenticatedAssetsRoute
  '/calibration-management': typeof AuthenticatedCalibrationManagementRoute
  '/certificates': typeof AuthenticatedCertificatesRoute
  '/checklist-management': typeof AuthenticatedChecklistManagementRouteWithChildren
  '/files': typeof AuthenticatedFilesRoute
  '/gamification': typeof AuthenticatedGamificationRoute
  '/home': typeof AuthenticatedHomeRoute
  '/integrations': typeof AuthenticatedIntegrationsRouteWithChildren
  '/knowledge-center': typeof AuthenticatedKnowledgeCenterRoute
  '/my-work': typeof AuthenticatedMyWorkRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/parameter-management': typeof AuthenticatedParameterManagementRoute
  '/parts-management': typeof AuthenticatedPartsManagementRouteWithChildren
  '/preventive-maintenance': typeof AuthenticatedPreventiveMaintenanceRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/purchase-requests': typeof AuthenticatedPurchaseRequestsRoute
  '/reliability': typeof AuthenticatedReliabilityRoute
  '/reports': typeof AuthenticatedReportsRouteWithChildren
  '/settings': typeof AuthenticatedSettingsRoute
  '/shift-management': typeof AuthenticatedShiftManagementRoute
  '/supplier-certificates': typeof AuthenticatedSupplierCertificatesRoute
  '/teams': typeof AuthenticatedTeamsRoute
  '/tickets': typeof AuthenticatedTicketsRoute
  '/training': typeof AuthenticatedTrainingRoute
  '/training-management': typeof AuthenticatedTrainingManagementRoute
  '/user-management': typeof AuthenticatedUserManagementRoute
  '/users': typeof AuthenticatedUsersRoute
  '/work-orders': typeof AuthenticatedWorkOrdersRouteWithChildren
  '/analytics/asset-status-segments': typeof AuthenticatedAnalyticsAssetStatusSegmentsRoute
  '/analytics/custom-dashboard': typeof AuthenticatedAnalyticsCustomDashboardRoute
  '/analytics/insights': typeof AuthenticatedAnalyticsInsightsRoute
  '/analytics/parts-stock': typeof AuthenticatedAnalyticsPartsStockRoute
  '/analytics/personnel-performance': typeof AuthenticatedAnalyticsPersonnelPerformanceRoute
  '/analytics/reports': typeof AuthenticatedAnalyticsReportsRoute
  '/asset/$assetId': typeof AuthenticatedAssetAssetIdRoute
  '/checklist-management/instances': typeof AuthenticatedChecklistManagementInstancesRoute
  '/checklist-management/templates': typeof AuthenticatedChecklistManagementTemplatesRoute
  '/compliance/audit-log': typeof AuthenticatedComplianceAuditLogRoute
  '/compliance/certificates': typeof AuthenticatedComplianceCertificatesRoute
  '/compliance/dashboard': typeof AuthenticatedComplianceDashboardRoute
  '/compliance/loto-permits': typeof AuthenticatedComplianceLotoPermitsRoute
  '/compliance/regulations': typeof AuthenticatedComplianceRegulationsRoute
  '/compliance/safety': typeof AuthenticatedComplianceSafetyRoute
  '/integrations/api': typeof AuthenticatedIntegrationsApiRoute
  '/integrations/webhooks': typeof AuthenticatedIntegrationsWebhooksRouteWithChildren
  '/parts-management/categories': typeof AuthenticatedPartsManagementCategoriesRoute
  '/parts-management/suppliers': typeof AuthenticatedPartsManagementSuppliersRoute
  '/reports/ai-builder': typeof AuthenticatedReportsAiBuilderRoute
  '/reports/benchmarks': typeof AuthenticatedReportsBenchmarksRoute
  '/reports/dashboards': typeof AuthenticatedReportsDashboardsRoute
  '/reports/history': typeof AuthenticatedReportsHistoryRoute
  '/reports/scheduled': typeof AuthenticatedReportsScheduledRoute
  '/reports/templates': typeof AuthenticatedReportsTemplatesRoute
  '/user/$userId': typeof AuthenticatedUserUserIdRoute
  '/work-orders/$workOrderId': typeof AuthenticatedWorkOrdersWorkOrderIdRoute
  '/admin/': typeof AuthenticatedAdminIndexRoute
  '/analytics/': typeof AuthenticatedAnalyticsIndexRoute
  '/compliance/': typeof AuthenticatedComplianceIndexRoute
  '/parts-management/': typeof AuthenticatedPartsManagementIndexRoute
  '/reports/': typeof AuthenticatedReportsIndexRoute
  '/work-orders/': typeof AuthenticatedWorkOrdersIndexRoute
  '/admin/workflows/$workflowId': typeof AuthenticatedAdminWorkflowsWorkflowIdRoute
  '/integrations/webhooks/$id': typeof AuthenticatedIntegrationsWebhooksIdRouteWithChildren
  '/integrations/webhooks/create': typeof AuthenticatedIntegrationsWebhooksCreateRoute
  '/admin/workflows/': typeof AuthenticatedAdminWorkflowsIndexRoute
  '/integrations/webhooks/': typeof AuthenticatedIntegrationsWebhooksIndexRoute
  '/integrations/webhooks/$id/edit': typeof AuthenticatedIntegrationsWebhooksIdEditRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/api-docs': typeof AuthenticatedApiDocsRoute
  '/asset-management': typeof AuthenticatedAssetManagementRoute
  '/asset-status-events': typeof AuthenticatedAssetStatusEventsRoute
  '/asset-statuses': typeof AuthenticatedAssetStatusesRoute
  '/assets': typeof AuthenticatedAssetsRoute
  '/calibration-management': typeof AuthenticatedCalibrationManagementRoute
  '/certificates': typeof AuthenticatedCertificatesRoute
  '/checklist-management': typeof AuthenticatedChecklistManagementRouteWithChildren
  '/files': typeof AuthenticatedFilesRoute
  '/gamification': typeof AuthenticatedGamificationRoute
  '/home': typeof AuthenticatedHomeRoute
  '/integrations': typeof AuthenticatedIntegrationsRouteWithChildren
  '/knowledge-center': typeof AuthenticatedKnowledgeCenterRoute
  '/my-work': typeof AuthenticatedMyWorkRoute
  '/notifications': typeof AuthenticatedNotificationsRoute
  '/parameter-management': typeof AuthenticatedParameterManagementRoute
  '/preventive-maintenance': typeof AuthenticatedPreventiveMaintenanceRoute
  '/profile': typeof AuthenticatedProfileRoute
  '/purchase-requests': typeof AuthenticatedPurchaseRequestsRoute
  '/reliability': typeof AuthenticatedReliabilityRoute
  '/settings': typeof AuthenticatedSettingsRoute
  '/shift-management': typeof AuthenticatedShiftManagementRoute
  '/supplier-certificates': typeof AuthenticatedSupplierCertificatesRoute
  '/teams': typeof AuthenticatedTeamsRoute
  '/tickets': typeof AuthenticatedTicketsRoute
  '/training': typeof AuthenticatedTrainingRoute
  '/training-management': typeof AuthenticatedTrainingManagementRoute
  '/user-management': typeof AuthenticatedUserManagementRoute
  '/users': typeof AuthenticatedUsersRoute
  '/analytics/asset-status-segments': typeof AuthenticatedAnalyticsAssetStatusSegmentsRoute
  '/analytics/custom-dashboard': typeof AuthenticatedAnalyticsCustomDashboardRoute
  '/analytics/insights': typeof AuthenticatedAnalyticsInsightsRoute
  '/analytics/parts-stock': typeof AuthenticatedAnalyticsPartsStockRoute
  '/analytics/personnel-performance': typeof AuthenticatedAnalyticsPersonnelPerformanceRoute
  '/analytics/reports': typeof AuthenticatedAnalyticsReportsRoute
  '/asset/$assetId': typeof AuthenticatedAssetAssetIdRoute
  '/checklist-management/instances': typeof AuthenticatedChecklistManagementInstancesRoute
  '/checklist-management/templates': typeof AuthenticatedChecklistManagementTemplatesRoute
  '/compliance/audit-log': typeof AuthenticatedComplianceAuditLogRoute
  '/compliance/certificates': typeof AuthenticatedComplianceCertificatesRoute
  '/compliance/dashboard': typeof AuthenticatedComplianceDashboardRoute
  '/compliance/loto-permits': typeof AuthenticatedComplianceLotoPermitsRoute
  '/compliance/regulations': typeof AuthenticatedComplianceRegulationsRoute
  '/compliance/safety': typeof AuthenticatedComplianceSafetyRoute
  '/integrations/api': typeof AuthenticatedIntegrationsApiRoute
  '/parts-management/categories': typeof AuthenticatedPartsManagementCategoriesRoute
  '/parts-management/suppliers': typeof AuthenticatedPartsManagementSuppliersRoute
  '/reports/ai-builder': typeof AuthenticatedReportsAiBuilderRoute
  '/reports/benchmarks': typeof AuthenticatedReportsBenchmarksRoute
  '/reports/dashboards': typeof AuthenticatedReportsDashboardsRoute
  '/reports/history': typeof AuthenticatedReportsHistoryRoute
  '/reports/scheduled': typeof AuthenticatedReportsScheduledRoute
  '/reports/templates': typeof AuthenticatedReportsTemplatesRoute
  '/user/$userId': typeof AuthenticatedUserUserIdRoute
  '/work-orders/$workOrderId': typeof AuthenticatedWorkOrdersWorkOrderIdRoute
  '/admin': typeof AuthenticatedAdminIndexRoute
  '/analytics': typeof AuthenticatedAnalyticsIndexRoute
  '/compliance': typeof AuthenticatedComplianceIndexRoute
  '/parts-management': typeof AuthenticatedPartsManagementIndexRoute
  '/reports': typeof AuthenticatedReportsIndexRoute
  '/work-orders': typeof AuthenticatedWorkOrdersIndexRoute
  '/admin/workflows/$workflowId': typeof AuthenticatedAdminWorkflowsWorkflowIdRoute
  '/integrations/webhooks/$id': typeof AuthenticatedIntegrationsWebhooksIdRouteWithChildren
  '/integrations/webhooks/create': typeof AuthenticatedIntegrationsWebhooksCreateRoute
  '/admin/workflows': typeof AuthenticatedAdminWorkflowsIndexRoute
  '/integrations/webhooks': typeof AuthenticatedIntegrationsWebhooksIndexRoute
  '/integrations/webhooks/$id/edit': typeof AuthenticatedIntegrationsWebhooksIdEditRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/login': typeof LoginRoute
  '/register': typeof RegisterRoute
  '/_authenticated/analytics': typeof AuthenticatedAnalyticsRouteWithChildren
  '/_authenticated/api-docs': typeof AuthenticatedApiDocsRoute
  '/_authenticated/asset-management': typeof AuthenticatedAssetManagementRoute
  '/_authenticated/asset-status-events': typeof AuthenticatedAssetStatusEventsRoute
  '/_authenticated/asset-statuses': typeof AuthenticatedAssetStatusesRoute
  '/_authenticated/assets': typeof AuthenticatedAssetsRoute
  '/_authenticated/calibration-management': typeof AuthenticatedCalibrationManagementRoute
  '/_authenticated/certificates': typeof AuthenticatedCertificatesRoute
  '/_authenticated/checklist-management': typeof AuthenticatedChecklistManagementRouteWithChildren
  '/_authenticated/files': typeof AuthenticatedFilesRoute
  '/_authenticated/gamification': typeof AuthenticatedGamificationRoute
  '/_authenticated/home': typeof AuthenticatedHomeRoute
  '/_authenticated/integrations': typeof AuthenticatedIntegrationsRouteWithChildren
  '/_authenticated/knowledge-center': typeof AuthenticatedKnowledgeCenterRoute
  '/_authenticated/my-work': typeof AuthenticatedMyWorkRoute
  '/_authenticated/notifications': typeof AuthenticatedNotificationsRoute
  '/_authenticated/parameter-management': typeof AuthenticatedParameterManagementRoute
  '/_authenticated/parts-management': typeof AuthenticatedPartsManagementRouteWithChildren
  '/_authenticated/preventive-maintenance': typeof AuthenticatedPreventiveMaintenanceRoute
  '/_authenticated/profile': typeof AuthenticatedProfileRoute
  '/_authenticated/purchase-requests': typeof AuthenticatedPurchaseRequestsRoute
  '/_authenticated/reliability': typeof AuthenticatedReliabilityRoute
  '/_authenticated/reports': typeof AuthenticatedReportsRouteWithChildren
  '/_authenticated/settings': typeof AuthenticatedSettingsRoute
  '/_authenticated/shift-management': typeof AuthenticatedShiftManagementRoute
  '/_authenticated/supplier-certificates': typeof AuthenticatedSupplierCertificatesRoute
  '/_authenticated/teams': typeof AuthenticatedTeamsRoute
  '/_authenticated/tickets': typeof AuthenticatedTicketsRoute
  '/_authenticated/training': typeof AuthenticatedTrainingRoute
  '/_authenticated/training-management': typeof AuthenticatedTrainingManagementRoute
  '/_authenticated/user-management': typeof AuthenticatedUserManagementRoute
  '/_authenticated/users': typeof AuthenticatedUsersRoute
  '/_authenticated/work-orders': typeof AuthenticatedWorkOrdersRouteWithChildren
  '/_authenticated/analytics/asset-status-segments': typeof AuthenticatedAnalyticsAssetStatusSegmentsRoute
  '/_authenticated/analytics/custom-dashboard': typeof AuthenticatedAnalyticsCustomDashboardRoute
  '/_authenticated/analytics/insights': typeof AuthenticatedAnalyticsInsightsRoute
  '/_authenticated/analytics/parts-stock': typeof AuthenticatedAnalyticsPartsStockRoute
  '/_authenticated/analytics/personnel-performance': typeof AuthenticatedAnalyticsPersonnelPerformanceRoute
  '/_authenticated/analytics/reports': typeof AuthenticatedAnalyticsReportsRoute
  '/_authenticated/asset/$assetId': typeof AuthenticatedAssetAssetIdRoute
  '/_authenticated/checklist-management/instances': typeof AuthenticatedChecklistManagementInstancesRoute
  '/_authenticated/checklist-management/templates': typeof AuthenticatedChecklistManagementTemplatesRoute
  '/_authenticated/compliance/audit-log': typeof AuthenticatedComplianceAuditLogRoute
  '/_authenticated/compliance/certificates': typeof AuthenticatedComplianceCertificatesRoute
  '/_authenticated/compliance/dashboard': typeof AuthenticatedComplianceDashboardRoute
  '/_authenticated/compliance/loto-permits': typeof AuthenticatedComplianceLotoPermitsRoute
  '/_authenticated/compliance/regulations': typeof AuthenticatedComplianceRegulationsRoute
  '/_authenticated/compliance/safety': typeof AuthenticatedComplianceSafetyRoute
  '/_authenticated/integrations/api': typeof AuthenticatedIntegrationsApiRoute
  '/_authenticated/integrations/webhooks': typeof AuthenticatedIntegrationsWebhooksRouteWithChildren
  '/_authenticated/parts-management/categories': typeof AuthenticatedPartsManagementCategoriesRoute
  '/_authenticated/parts-management/suppliers': typeof AuthenticatedPartsManagementSuppliersRoute
  '/_authenticated/reports/ai-builder': typeof AuthenticatedReportsAiBuilderRoute
  '/_authenticated/reports/benchmarks': typeof AuthenticatedReportsBenchmarksRoute
  '/_authenticated/reports/dashboards': typeof AuthenticatedReportsDashboardsRoute
  '/_authenticated/reports/history': typeof AuthenticatedReportsHistoryRoute
  '/_authenticated/reports/scheduled': typeof AuthenticatedReportsScheduledRoute
  '/_authenticated/reports/templates': typeof AuthenticatedReportsTemplatesRoute
  '/_authenticated/user/$userId': typeof AuthenticatedUserUserIdRoute
  '/_authenticated/work-orders/$workOrderId': typeof AuthenticatedWorkOrdersWorkOrderIdRoute
  '/_authenticated/admin/': typeof AuthenticatedAdminIndexRoute
  '/_authenticated/analytics/': typeof AuthenticatedAnalyticsIndexRoute
  '/_authenticated/compliance/': typeof AuthenticatedComplianceIndexRoute
  '/_authenticated/parts-management/': typeof AuthenticatedPartsManagementIndexRoute
  '/_authenticated/reports/': typeof AuthenticatedReportsIndexRoute
  '/_authenticated/work-orders/': typeof AuthenticatedWorkOrdersIndexRoute
  '/_authenticated/admin/workflows/$workflowId': typeof AuthenticatedAdminWorkflowsWorkflowIdRoute
  '/_authenticated/integrations/webhooks/$id': typeof AuthenticatedIntegrationsWebhooksIdRouteWithChildren
  '/_authenticated/integrations/webhooks/create': typeof AuthenticatedIntegrationsWebhooksCreateRoute
  '/_authenticated/admin/workflows/': typeof AuthenticatedAdminWorkflowsIndexRoute
  '/_authenticated/integrations/webhooks/': typeof AuthenticatedIntegrationsWebhooksIndexRoute
  '/_authenticated/integrations/webhooks/$id/edit': typeof AuthenticatedIntegrationsWebhooksIdEditRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/register'
    | '/analytics'
    | '/api-docs'
    | '/asset-management'
    | '/asset-status-events'
    | '/asset-statuses'
    | '/assets'
    | '/calibration-management'
    | '/certificates'
    | '/checklist-management'
    | '/files'
    | '/gamification'
    | '/home'
    | '/integrations'
    | '/knowledge-center'
    | '/my-work'
    | '/notifications'
    | '/parameter-management'
    | '/parts-management'
    | '/preventive-maintenance'
    | '/profile'
    | '/purchase-requests'
    | '/reliability'
    | '/reports'
    | '/settings'
    | '/shift-management'
    | '/supplier-certificates'
    | '/teams'
    | '/tickets'
    | '/training'
    | '/training-management'
    | '/user-management'
    | '/users'
    | '/work-orders'
    | '/analytics/asset-status-segments'
    | '/analytics/custom-dashboard'
    | '/analytics/insights'
    | '/analytics/parts-stock'
    | '/analytics/personnel-performance'
    | '/analytics/reports'
    | '/asset/$assetId'
    | '/checklist-management/instances'
    | '/checklist-management/templates'
    | '/compliance/audit-log'
    | '/compliance/certificates'
    | '/compliance/dashboard'
    | '/compliance/loto-permits'
    | '/compliance/regulations'
    | '/compliance/safety'
    | '/integrations/api'
    | '/integrations/webhooks'
    | '/parts-management/categories'
    | '/parts-management/suppliers'
    | '/reports/ai-builder'
    | '/reports/benchmarks'
    | '/reports/dashboards'
    | '/reports/history'
    | '/reports/scheduled'
    | '/reports/templates'
    | '/user/$userId'
    | '/work-orders/$workOrderId'
    | '/admin/'
    | '/analytics/'
    | '/compliance/'
    | '/parts-management/'
    | '/reports/'
    | '/work-orders/'
    | '/admin/workflows/$workflowId'
    | '/integrations/webhooks/$id'
    | '/integrations/webhooks/create'
    | '/admin/workflows/'
    | '/integrations/webhooks/'
    | '/integrations/webhooks/$id/edit'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/register'
    | '/api-docs'
    | '/asset-management'
    | '/asset-status-events'
    | '/asset-statuses'
    | '/assets'
    | '/calibration-management'
    | '/certificates'
    | '/checklist-management'
    | '/files'
    | '/gamification'
    | '/home'
    | '/integrations'
    | '/knowledge-center'
    | '/my-work'
    | '/notifications'
    | '/parameter-management'
    | '/preventive-maintenance'
    | '/profile'
    | '/purchase-requests'
    | '/reliability'
    | '/settings'
    | '/shift-management'
    | '/supplier-certificates'
    | '/teams'
    | '/tickets'
    | '/training'
    | '/training-management'
    | '/user-management'
    | '/users'
    | '/analytics/asset-status-segments'
    | '/analytics/custom-dashboard'
    | '/analytics/insights'
    | '/analytics/parts-stock'
    | '/analytics/personnel-performance'
    | '/analytics/reports'
    | '/asset/$assetId'
    | '/checklist-management/instances'
    | '/checklist-management/templates'
    | '/compliance/audit-log'
    | '/compliance/certificates'
    | '/compliance/dashboard'
    | '/compliance/loto-permits'
    | '/compliance/regulations'
    | '/compliance/safety'
    | '/integrations/api'
    | '/parts-management/categories'
    | '/parts-management/suppliers'
    | '/reports/ai-builder'
    | '/reports/benchmarks'
    | '/reports/dashboards'
    | '/reports/history'
    | '/reports/scheduled'
    | '/reports/templates'
    | '/user/$userId'
    | '/work-orders/$workOrderId'
    | '/admin'
    | '/analytics'
    | '/compliance'
    | '/parts-management'
    | '/reports'
    | '/work-orders'
    | '/admin/workflows/$workflowId'
    | '/integrations/webhooks/$id'
    | '/integrations/webhooks/create'
    | '/admin/workflows'
    | '/integrations/webhooks'
    | '/integrations/webhooks/$id/edit'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/login'
    | '/register'
    | '/_authenticated/analytics'
    | '/_authenticated/api-docs'
    | '/_authenticated/asset-management'
    | '/_authenticated/asset-status-events'
    | '/_authenticated/asset-statuses'
    | '/_authenticated/assets'
    | '/_authenticated/calibration-management'
    | '/_authenticated/certificates'
    | '/_authenticated/checklist-management'
    | '/_authenticated/files'
    | '/_authenticated/gamification'
    | '/_authenticated/home'
    | '/_authenticated/integrations'
    | '/_authenticated/knowledge-center'
    | '/_authenticated/my-work'
    | '/_authenticated/notifications'
    | '/_authenticated/parameter-management'
    | '/_authenticated/parts-management'
    | '/_authenticated/preventive-maintenance'
    | '/_authenticated/profile'
    | '/_authenticated/purchase-requests'
    | '/_authenticated/reliability'
    | '/_authenticated/reports'
    | '/_authenticated/settings'
    | '/_authenticated/shift-management'
    | '/_authenticated/supplier-certificates'
    | '/_authenticated/teams'
    | '/_authenticated/tickets'
    | '/_authenticated/training'
    | '/_authenticated/training-management'
    | '/_authenticated/user-management'
    | '/_authenticated/users'
    | '/_authenticated/work-orders'
    | '/_authenticated/analytics/asset-status-segments'
    | '/_authenticated/analytics/custom-dashboard'
    | '/_authenticated/analytics/insights'
    | '/_authenticated/analytics/parts-stock'
    | '/_authenticated/analytics/personnel-performance'
    | '/_authenticated/analytics/reports'
    | '/_authenticated/asset/$assetId'
    | '/_authenticated/checklist-management/instances'
    | '/_authenticated/checklist-management/templates'
    | '/_authenticated/compliance/audit-log'
    | '/_authenticated/compliance/certificates'
    | '/_authenticated/compliance/dashboard'
    | '/_authenticated/compliance/loto-permits'
    | '/_authenticated/compliance/regulations'
    | '/_authenticated/compliance/safety'
    | '/_authenticated/integrations/api'
    | '/_authenticated/integrations/webhooks'
    | '/_authenticated/parts-management/categories'
    | '/_authenticated/parts-management/suppliers'
    | '/_authenticated/reports/ai-builder'
    | '/_authenticated/reports/benchmarks'
    | '/_authenticated/reports/dashboards'
    | '/_authenticated/reports/history'
    | '/_authenticated/reports/scheduled'
    | '/_authenticated/reports/templates'
    | '/_authenticated/user/$userId'
    | '/_authenticated/work-orders/$workOrderId'
    | '/_authenticated/admin/'
    | '/_authenticated/analytics/'
    | '/_authenticated/compliance/'
    | '/_authenticated/parts-management/'
    | '/_authenticated/reports/'
    | '/_authenticated/work-orders/'
    | '/_authenticated/admin/workflows/$workflowId'
    | '/_authenticated/integrations/webhooks/$id'
    | '/_authenticated/integrations/webhooks/create'
    | '/_authenticated/admin/workflows/'
    | '/_authenticated/integrations/webhooks/'
    | '/_authenticated/integrations/webhooks/$id/edit'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  LoginRoute: typeof LoginRoute
  RegisterRoute: typeof RegisterRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/register': {
      id: '/register'
      path: '/register'
      fullPath: '/register'
      preLoaderRoute: typeof RegisterRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/work-orders': {
      id: '/_authenticated/work-orders'
      path: '/work-orders'
      fullPath: '/work-orders'
      preLoaderRoute: typeof AuthenticatedWorkOrdersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/users': {
      id: '/_authenticated/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof AuthenticatedUsersRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/user-management': {
      id: '/_authenticated/user-management'
      path: '/user-management'
      fullPath: '/user-management'
      preLoaderRoute: typeof AuthenticatedUserManagementRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/training-management': {
      id: '/_authenticated/training-management'
      path: '/training-management'
      fullPath: '/training-management'
      preLoaderRoute: typeof AuthenticatedTrainingManagementRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/training': {
      id: '/_authenticated/training'
      path: '/training'
      fullPath: '/training'
      preLoaderRoute: typeof AuthenticatedTrainingRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/tickets': {
      id: '/_authenticated/tickets'
      path: '/tickets'
      fullPath: '/tickets'
      preLoaderRoute: typeof AuthenticatedTicketsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/teams': {
      id: '/_authenticated/teams'
      path: '/teams'
      fullPath: '/teams'
      preLoaderRoute: typeof AuthenticatedTeamsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/supplier-certificates': {
      id: '/_authenticated/supplier-certificates'
      path: '/supplier-certificates'
      fullPath: '/supplier-certificates'
      preLoaderRoute: typeof AuthenticatedSupplierCertificatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/shift-management': {
      id: '/_authenticated/shift-management'
      path: '/shift-management'
      fullPath: '/shift-management'
      preLoaderRoute: typeof AuthenticatedShiftManagementRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports': {
      id: '/_authenticated/reports'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof AuthenticatedReportsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reliability': {
      id: '/_authenticated/reliability'
      path: '/reliability'
      fullPath: '/reliability'
      preLoaderRoute: typeof AuthenticatedReliabilityRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/purchase-requests': {
      id: '/_authenticated/purchase-requests'
      path: '/purchase-requests'
      fullPath: '/purchase-requests'
      preLoaderRoute: typeof AuthenticatedPurchaseRequestsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/profile': {
      id: '/_authenticated/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof AuthenticatedProfileRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/preventive-maintenance': {
      id: '/_authenticated/preventive-maintenance'
      path: '/preventive-maintenance'
      fullPath: '/preventive-maintenance'
      preLoaderRoute: typeof AuthenticatedPreventiveMaintenanceRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/parts-management': {
      id: '/_authenticated/parts-management'
      path: '/parts-management'
      fullPath: '/parts-management'
      preLoaderRoute: typeof AuthenticatedPartsManagementRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/parameter-management': {
      id: '/_authenticated/parameter-management'
      path: '/parameter-management'
      fullPath: '/parameter-management'
      preLoaderRoute: typeof AuthenticatedParameterManagementRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/notifications': {
      id: '/_authenticated/notifications'
      path: '/notifications'
      fullPath: '/notifications'
      preLoaderRoute: typeof AuthenticatedNotificationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/my-work': {
      id: '/_authenticated/my-work'
      path: '/my-work'
      fullPath: '/my-work'
      preLoaderRoute: typeof AuthenticatedMyWorkRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/knowledge-center': {
      id: '/_authenticated/knowledge-center'
      path: '/knowledge-center'
      fullPath: '/knowledge-center'
      preLoaderRoute: typeof AuthenticatedKnowledgeCenterRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/integrations': {
      id: '/_authenticated/integrations'
      path: '/integrations'
      fullPath: '/integrations'
      preLoaderRoute: typeof AuthenticatedIntegrationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/home': {
      id: '/_authenticated/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof AuthenticatedHomeRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/gamification': {
      id: '/_authenticated/gamification'
      path: '/gamification'
      fullPath: '/gamification'
      preLoaderRoute: typeof AuthenticatedGamificationRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/files': {
      id: '/_authenticated/files'
      path: '/files'
      fullPath: '/files'
      preLoaderRoute: typeof AuthenticatedFilesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/checklist-management': {
      id: '/_authenticated/checklist-management'
      path: '/checklist-management'
      fullPath: '/checklist-management'
      preLoaderRoute: typeof AuthenticatedChecklistManagementRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/certificates': {
      id: '/_authenticated/certificates'
      path: '/certificates'
      fullPath: '/certificates'
      preLoaderRoute: typeof AuthenticatedCertificatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/calibration-management': {
      id: '/_authenticated/calibration-management'
      path: '/calibration-management'
      fullPath: '/calibration-management'
      preLoaderRoute: typeof AuthenticatedCalibrationManagementRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/assets': {
      id: '/_authenticated/assets'
      path: '/assets'
      fullPath: '/assets'
      preLoaderRoute: typeof AuthenticatedAssetsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/asset-statuses': {
      id: '/_authenticated/asset-statuses'
      path: '/asset-statuses'
      fullPath: '/asset-statuses'
      preLoaderRoute: typeof AuthenticatedAssetStatusesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/asset-status-events': {
      id: '/_authenticated/asset-status-events'
      path: '/asset-status-events'
      fullPath: '/asset-status-events'
      preLoaderRoute: typeof AuthenticatedAssetStatusEventsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/asset-management': {
      id: '/_authenticated/asset-management'
      path: '/asset-management'
      fullPath: '/asset-management'
      preLoaderRoute: typeof AuthenticatedAssetManagementRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/api-docs': {
      id: '/_authenticated/api-docs'
      path: '/api-docs'
      fullPath: '/api-docs'
      preLoaderRoute: typeof AuthenticatedApiDocsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/analytics': {
      id: '/_authenticated/analytics'
      path: '/analytics'
      fullPath: '/analytics'
      preLoaderRoute: typeof AuthenticatedAnalyticsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/work-orders/': {
      id: '/_authenticated/work-orders/'
      path: '/'
      fullPath: '/work-orders/'
      preLoaderRoute: typeof AuthenticatedWorkOrdersIndexRouteImport
      parentRoute: typeof AuthenticatedWorkOrdersRoute
    }
    '/_authenticated/reports/': {
      id: '/_authenticated/reports/'
      path: '/'
      fullPath: '/reports/'
      preLoaderRoute: typeof AuthenticatedReportsIndexRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/parts-management/': {
      id: '/_authenticated/parts-management/'
      path: '/'
      fullPath: '/parts-management/'
      preLoaderRoute: typeof AuthenticatedPartsManagementIndexRouteImport
      parentRoute: typeof AuthenticatedPartsManagementRoute
    }
    '/_authenticated/compliance/': {
      id: '/_authenticated/compliance/'
      path: '/compliance'
      fullPath: '/compliance/'
      preLoaderRoute: typeof AuthenticatedComplianceIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/analytics/': {
      id: '/_authenticated/analytics/'
      path: '/'
      fullPath: '/analytics/'
      preLoaderRoute: typeof AuthenticatedAnalyticsIndexRouteImport
      parentRoute: typeof AuthenticatedAnalyticsRoute
    }
    '/_authenticated/admin/': {
      id: '/_authenticated/admin/'
      path: '/admin'
      fullPath: '/admin/'
      preLoaderRoute: typeof AuthenticatedAdminIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/work-orders/$workOrderId': {
      id: '/_authenticated/work-orders/$workOrderId'
      path: '/$workOrderId'
      fullPath: '/work-orders/$workOrderId'
      preLoaderRoute: typeof AuthenticatedWorkOrdersWorkOrderIdRouteImport
      parentRoute: typeof AuthenticatedWorkOrdersRoute
    }
    '/_authenticated/user/$userId': {
      id: '/_authenticated/user/$userId'
      path: '/user/$userId'
      fullPath: '/user/$userId'
      preLoaderRoute: typeof AuthenticatedUserUserIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/reports/templates': {
      id: '/_authenticated/reports/templates'
      path: '/templates'
      fullPath: '/reports/templates'
      preLoaderRoute: typeof AuthenticatedReportsTemplatesRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/scheduled': {
      id: '/_authenticated/reports/scheduled'
      path: '/scheduled'
      fullPath: '/reports/scheduled'
      preLoaderRoute: typeof AuthenticatedReportsScheduledRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/history': {
      id: '/_authenticated/reports/history'
      path: '/history'
      fullPath: '/reports/history'
      preLoaderRoute: typeof AuthenticatedReportsHistoryRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/dashboards': {
      id: '/_authenticated/reports/dashboards'
      path: '/dashboards'
      fullPath: '/reports/dashboards'
      preLoaderRoute: typeof AuthenticatedReportsDashboardsRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/benchmarks': {
      id: '/_authenticated/reports/benchmarks'
      path: '/benchmarks'
      fullPath: '/reports/benchmarks'
      preLoaderRoute: typeof AuthenticatedReportsBenchmarksRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/reports/ai-builder': {
      id: '/_authenticated/reports/ai-builder'
      path: '/ai-builder'
      fullPath: '/reports/ai-builder'
      preLoaderRoute: typeof AuthenticatedReportsAiBuilderRouteImport
      parentRoute: typeof AuthenticatedReportsRoute
    }
    '/_authenticated/parts-management/suppliers': {
      id: '/_authenticated/parts-management/suppliers'
      path: '/suppliers'
      fullPath: '/parts-management/suppliers'
      preLoaderRoute: typeof AuthenticatedPartsManagementSuppliersRouteImport
      parentRoute: typeof AuthenticatedPartsManagementRoute
    }
    '/_authenticated/parts-management/categories': {
      id: '/_authenticated/parts-management/categories'
      path: '/categories'
      fullPath: '/parts-management/categories'
      preLoaderRoute: typeof AuthenticatedPartsManagementCategoriesRouteImport
      parentRoute: typeof AuthenticatedPartsManagementRoute
    }
    '/_authenticated/integrations/webhooks': {
      id: '/_authenticated/integrations/webhooks'
      path: '/webhooks'
      fullPath: '/integrations/webhooks'
      preLoaderRoute: typeof AuthenticatedIntegrationsWebhooksRouteImport
      parentRoute: typeof AuthenticatedIntegrationsRoute
    }
    '/_authenticated/integrations/api': {
      id: '/_authenticated/integrations/api'
      path: '/api'
      fullPath: '/integrations/api'
      preLoaderRoute: typeof AuthenticatedIntegrationsApiRouteImport
      parentRoute: typeof AuthenticatedIntegrationsRoute
    }
    '/_authenticated/compliance/safety': {
      id: '/_authenticated/compliance/safety'
      path: '/compliance/safety'
      fullPath: '/compliance/safety'
      preLoaderRoute: typeof AuthenticatedComplianceSafetyRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/compliance/regulations': {
      id: '/_authenticated/compliance/regulations'
      path: '/compliance/regulations'
      fullPath: '/compliance/regulations'
      preLoaderRoute: typeof AuthenticatedComplianceRegulationsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/compliance/loto-permits': {
      id: '/_authenticated/compliance/loto-permits'
      path: '/compliance/loto-permits'
      fullPath: '/compliance/loto-permits'
      preLoaderRoute: typeof AuthenticatedComplianceLotoPermitsRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/compliance/dashboard': {
      id: '/_authenticated/compliance/dashboard'
      path: '/compliance/dashboard'
      fullPath: '/compliance/dashboard'
      preLoaderRoute: typeof AuthenticatedComplianceDashboardRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/compliance/certificates': {
      id: '/_authenticated/compliance/certificates'
      path: '/compliance/certificates'
      fullPath: '/compliance/certificates'
      preLoaderRoute: typeof AuthenticatedComplianceCertificatesRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/compliance/audit-log': {
      id: '/_authenticated/compliance/audit-log'
      path: '/compliance/audit-log'
      fullPath: '/compliance/audit-log'
      preLoaderRoute: typeof AuthenticatedComplianceAuditLogRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/checklist-management/templates': {
      id: '/_authenticated/checklist-management/templates'
      path: '/templates'
      fullPath: '/checklist-management/templates'
      preLoaderRoute: typeof AuthenticatedChecklistManagementTemplatesRouteImport
      parentRoute: typeof AuthenticatedChecklistManagementRoute
    }
    '/_authenticated/checklist-management/instances': {
      id: '/_authenticated/checklist-management/instances'
      path: '/instances'
      fullPath: '/checklist-management/instances'
      preLoaderRoute: typeof AuthenticatedChecklistManagementInstancesRouteImport
      parentRoute: typeof AuthenticatedChecklistManagementRoute
    }
    '/_authenticated/asset/$assetId': {
      id: '/_authenticated/asset/$assetId'
      path: '/asset/$assetId'
      fullPath: '/asset/$assetId'
      preLoaderRoute: typeof AuthenticatedAssetAssetIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/analytics/reports': {
      id: '/_authenticated/analytics/reports'
      path: '/reports'
      fullPath: '/analytics/reports'
      preLoaderRoute: typeof AuthenticatedAnalyticsReportsRouteImport
      parentRoute: typeof AuthenticatedAnalyticsRoute
    }
    '/_authenticated/analytics/personnel-performance': {
      id: '/_authenticated/analytics/personnel-performance'
      path: '/personnel-performance'
      fullPath: '/analytics/personnel-performance'
      preLoaderRoute: typeof AuthenticatedAnalyticsPersonnelPerformanceRouteImport
      parentRoute: typeof AuthenticatedAnalyticsRoute
    }
    '/_authenticated/analytics/parts-stock': {
      id: '/_authenticated/analytics/parts-stock'
      path: '/parts-stock'
      fullPath: '/analytics/parts-stock'
      preLoaderRoute: typeof AuthenticatedAnalyticsPartsStockRouteImport
      parentRoute: typeof AuthenticatedAnalyticsRoute
    }
    '/_authenticated/analytics/insights': {
      id: '/_authenticated/analytics/insights'
      path: '/insights'
      fullPath: '/analytics/insights'
      preLoaderRoute: typeof AuthenticatedAnalyticsInsightsRouteImport
      parentRoute: typeof AuthenticatedAnalyticsRoute
    }
    '/_authenticated/analytics/custom-dashboard': {
      id: '/_authenticated/analytics/custom-dashboard'
      path: '/custom-dashboard'
      fullPath: '/analytics/custom-dashboard'
      preLoaderRoute: typeof AuthenticatedAnalyticsCustomDashboardRouteImport
      parentRoute: typeof AuthenticatedAnalyticsRoute
    }
    '/_authenticated/analytics/asset-status-segments': {
      id: '/_authenticated/analytics/asset-status-segments'
      path: '/asset-status-segments'
      fullPath: '/analytics/asset-status-segments'
      preLoaderRoute: typeof AuthenticatedAnalyticsAssetStatusSegmentsRouteImport
      parentRoute: typeof AuthenticatedAnalyticsRoute
    }
    '/_authenticated/integrations/webhooks/': {
      id: '/_authenticated/integrations/webhooks/'
      path: '/'
      fullPath: '/integrations/webhooks/'
      preLoaderRoute: typeof AuthenticatedIntegrationsWebhooksIndexRouteImport
      parentRoute: typeof AuthenticatedIntegrationsWebhooksRoute
    }
    '/_authenticated/admin/workflows/': {
      id: '/_authenticated/admin/workflows/'
      path: '/admin/workflows'
      fullPath: '/admin/workflows/'
      preLoaderRoute: typeof AuthenticatedAdminWorkflowsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/integrations/webhooks/create': {
      id: '/_authenticated/integrations/webhooks/create'
      path: '/create'
      fullPath: '/integrations/webhooks/create'
      preLoaderRoute: typeof AuthenticatedIntegrationsWebhooksCreateRouteImport
      parentRoute: typeof AuthenticatedIntegrationsWebhooksRoute
    }
    '/_authenticated/integrations/webhooks/$id': {
      id: '/_authenticated/integrations/webhooks/$id'
      path: '/$id'
      fullPath: '/integrations/webhooks/$id'
      preLoaderRoute: typeof AuthenticatedIntegrationsWebhooksIdRouteImport
      parentRoute: typeof AuthenticatedIntegrationsWebhooksRoute
    }
    '/_authenticated/admin/workflows/$workflowId': {
      id: '/_authenticated/admin/workflows/$workflowId'
      path: '/admin/workflows/$workflowId'
      fullPath: '/admin/workflows/$workflowId'
      preLoaderRoute: typeof AuthenticatedAdminWorkflowsWorkflowIdRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/integrations/webhooks/$id/edit': {
      id: '/_authenticated/integrations/webhooks/$id/edit'
      path: '/edit'
      fullPath: '/integrations/webhooks/$id/edit'
      preLoaderRoute: typeof AuthenticatedIntegrationsWebhooksIdEditRouteImport
      parentRoute: typeof AuthenticatedIntegrationsWebhooksIdRoute
    }
  }
}

interface AuthenticatedAnalyticsRouteChildren {
  AuthenticatedAnalyticsAssetStatusSegmentsRoute: typeof AuthenticatedAnalyticsAssetStatusSegmentsRoute
  AuthenticatedAnalyticsCustomDashboardRoute: typeof AuthenticatedAnalyticsCustomDashboardRoute
  AuthenticatedAnalyticsInsightsRoute: typeof AuthenticatedAnalyticsInsightsRoute
  AuthenticatedAnalyticsPartsStockRoute: typeof AuthenticatedAnalyticsPartsStockRoute
  AuthenticatedAnalyticsPersonnelPerformanceRoute: typeof AuthenticatedAnalyticsPersonnelPerformanceRoute
  AuthenticatedAnalyticsReportsRoute: typeof AuthenticatedAnalyticsReportsRoute
  AuthenticatedAnalyticsIndexRoute: typeof AuthenticatedAnalyticsIndexRoute
}

const AuthenticatedAnalyticsRouteChildren: AuthenticatedAnalyticsRouteChildren =
  {
    AuthenticatedAnalyticsAssetStatusSegmentsRoute:
      AuthenticatedAnalyticsAssetStatusSegmentsRoute,
    AuthenticatedAnalyticsCustomDashboardRoute:
      AuthenticatedAnalyticsCustomDashboardRoute,
    AuthenticatedAnalyticsInsightsRoute: AuthenticatedAnalyticsInsightsRoute,
    AuthenticatedAnalyticsPartsStockRoute:
      AuthenticatedAnalyticsPartsStockRoute,
    AuthenticatedAnalyticsPersonnelPerformanceRoute:
      AuthenticatedAnalyticsPersonnelPerformanceRoute,
    AuthenticatedAnalyticsReportsRoute: AuthenticatedAnalyticsReportsRoute,
    AuthenticatedAnalyticsIndexRoute: AuthenticatedAnalyticsIndexRoute,
  }

const AuthenticatedAnalyticsRouteWithChildren =
  AuthenticatedAnalyticsRoute._addFileChildren(
    AuthenticatedAnalyticsRouteChildren,
  )

interface AuthenticatedChecklistManagementRouteChildren {
  AuthenticatedChecklistManagementInstancesRoute: typeof AuthenticatedChecklistManagementInstancesRoute
  AuthenticatedChecklistManagementTemplatesRoute: typeof AuthenticatedChecklistManagementTemplatesRoute
}

const AuthenticatedChecklistManagementRouteChildren: AuthenticatedChecklistManagementRouteChildren =
  {
    AuthenticatedChecklistManagementInstancesRoute:
      AuthenticatedChecklistManagementInstancesRoute,
    AuthenticatedChecklistManagementTemplatesRoute:
      AuthenticatedChecklistManagementTemplatesRoute,
  }

const AuthenticatedChecklistManagementRouteWithChildren =
  AuthenticatedChecklistManagementRoute._addFileChildren(
    AuthenticatedChecklistManagementRouteChildren,
  )

interface AuthenticatedIntegrationsWebhooksIdRouteChildren {
  AuthenticatedIntegrationsWebhooksIdEditRoute: typeof AuthenticatedIntegrationsWebhooksIdEditRoute
}

const AuthenticatedIntegrationsWebhooksIdRouteChildren: AuthenticatedIntegrationsWebhooksIdRouteChildren =
  {
    AuthenticatedIntegrationsWebhooksIdEditRoute:
      AuthenticatedIntegrationsWebhooksIdEditRoute,
  }

const AuthenticatedIntegrationsWebhooksIdRouteWithChildren =
  AuthenticatedIntegrationsWebhooksIdRoute._addFileChildren(
    AuthenticatedIntegrationsWebhooksIdRouteChildren,
  )

interface AuthenticatedIntegrationsWebhooksRouteChildren {
  AuthenticatedIntegrationsWebhooksIdRoute: typeof AuthenticatedIntegrationsWebhooksIdRouteWithChildren
  AuthenticatedIntegrationsWebhooksCreateRoute: typeof AuthenticatedIntegrationsWebhooksCreateRoute
  AuthenticatedIntegrationsWebhooksIndexRoute: typeof AuthenticatedIntegrationsWebhooksIndexRoute
}

const AuthenticatedIntegrationsWebhooksRouteChildren: AuthenticatedIntegrationsWebhooksRouteChildren =
  {
    AuthenticatedIntegrationsWebhooksIdRoute:
      AuthenticatedIntegrationsWebhooksIdRouteWithChildren,
    AuthenticatedIntegrationsWebhooksCreateRoute:
      AuthenticatedIntegrationsWebhooksCreateRoute,
    AuthenticatedIntegrationsWebhooksIndexRoute:
      AuthenticatedIntegrationsWebhooksIndexRoute,
  }

const AuthenticatedIntegrationsWebhooksRouteWithChildren =
  AuthenticatedIntegrationsWebhooksRoute._addFileChildren(
    AuthenticatedIntegrationsWebhooksRouteChildren,
  )

interface AuthenticatedIntegrationsRouteChildren {
  AuthenticatedIntegrationsApiRoute: typeof AuthenticatedIntegrationsApiRoute
  AuthenticatedIntegrationsWebhooksRoute: typeof AuthenticatedIntegrationsWebhooksRouteWithChildren
}

const AuthenticatedIntegrationsRouteChildren: AuthenticatedIntegrationsRouteChildren =
  {
    AuthenticatedIntegrationsApiRoute: AuthenticatedIntegrationsApiRoute,
    AuthenticatedIntegrationsWebhooksRoute:
      AuthenticatedIntegrationsWebhooksRouteWithChildren,
  }

const AuthenticatedIntegrationsRouteWithChildren =
  AuthenticatedIntegrationsRoute._addFileChildren(
    AuthenticatedIntegrationsRouteChildren,
  )

interface AuthenticatedPartsManagementRouteChildren {
  AuthenticatedPartsManagementCategoriesRoute: typeof AuthenticatedPartsManagementCategoriesRoute
  AuthenticatedPartsManagementSuppliersRoute: typeof AuthenticatedPartsManagementSuppliersRoute
  AuthenticatedPartsManagementIndexRoute: typeof AuthenticatedPartsManagementIndexRoute
}

const AuthenticatedPartsManagementRouteChildren: AuthenticatedPartsManagementRouteChildren =
  {
    AuthenticatedPartsManagementCategoriesRoute:
      AuthenticatedPartsManagementCategoriesRoute,
    AuthenticatedPartsManagementSuppliersRoute:
      AuthenticatedPartsManagementSuppliersRoute,
    AuthenticatedPartsManagementIndexRoute:
      AuthenticatedPartsManagementIndexRoute,
  }

const AuthenticatedPartsManagementRouteWithChildren =
  AuthenticatedPartsManagementRoute._addFileChildren(
    AuthenticatedPartsManagementRouteChildren,
  )

interface AuthenticatedReportsRouteChildren {
  AuthenticatedReportsAiBuilderRoute: typeof AuthenticatedReportsAiBuilderRoute
  AuthenticatedReportsBenchmarksRoute: typeof AuthenticatedReportsBenchmarksRoute
  AuthenticatedReportsDashboardsRoute: typeof AuthenticatedReportsDashboardsRoute
  AuthenticatedReportsHistoryRoute: typeof AuthenticatedReportsHistoryRoute
  AuthenticatedReportsScheduledRoute: typeof AuthenticatedReportsScheduledRoute
  AuthenticatedReportsTemplatesRoute: typeof AuthenticatedReportsTemplatesRoute
  AuthenticatedReportsIndexRoute: typeof AuthenticatedReportsIndexRoute
}

const AuthenticatedReportsRouteChildren: AuthenticatedReportsRouteChildren = {
  AuthenticatedReportsAiBuilderRoute: AuthenticatedReportsAiBuilderRoute,
  AuthenticatedReportsBenchmarksRoute: AuthenticatedReportsBenchmarksRoute,
  AuthenticatedReportsDashboardsRoute: AuthenticatedReportsDashboardsRoute,
  AuthenticatedReportsHistoryRoute: AuthenticatedReportsHistoryRoute,
  AuthenticatedReportsScheduledRoute: AuthenticatedReportsScheduledRoute,
  AuthenticatedReportsTemplatesRoute: AuthenticatedReportsTemplatesRoute,
  AuthenticatedReportsIndexRoute: AuthenticatedReportsIndexRoute,
}

const AuthenticatedReportsRouteWithChildren =
  AuthenticatedReportsRoute._addFileChildren(AuthenticatedReportsRouteChildren)

interface AuthenticatedWorkOrdersRouteChildren {
  AuthenticatedWorkOrdersWorkOrderIdRoute: typeof AuthenticatedWorkOrdersWorkOrderIdRoute
  AuthenticatedWorkOrdersIndexRoute: typeof AuthenticatedWorkOrdersIndexRoute
}

const AuthenticatedWorkOrdersRouteChildren: AuthenticatedWorkOrdersRouteChildren =
  {
    AuthenticatedWorkOrdersWorkOrderIdRoute:
      AuthenticatedWorkOrdersWorkOrderIdRoute,
    AuthenticatedWorkOrdersIndexRoute: AuthenticatedWorkOrdersIndexRoute,
  }

const AuthenticatedWorkOrdersRouteWithChildren =
  AuthenticatedWorkOrdersRoute._addFileChildren(
    AuthenticatedWorkOrdersRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedAnalyticsRoute: typeof AuthenticatedAnalyticsRouteWithChildren
  AuthenticatedApiDocsRoute: typeof AuthenticatedApiDocsRoute
  AuthenticatedAssetManagementRoute: typeof AuthenticatedAssetManagementRoute
  AuthenticatedAssetStatusEventsRoute: typeof AuthenticatedAssetStatusEventsRoute
  AuthenticatedAssetStatusesRoute: typeof AuthenticatedAssetStatusesRoute
  AuthenticatedAssetsRoute: typeof AuthenticatedAssetsRoute
  AuthenticatedCalibrationManagementRoute: typeof AuthenticatedCalibrationManagementRoute
  AuthenticatedCertificatesRoute: typeof AuthenticatedCertificatesRoute
  AuthenticatedChecklistManagementRoute: typeof AuthenticatedChecklistManagementRouteWithChildren
  AuthenticatedFilesRoute: typeof AuthenticatedFilesRoute
  AuthenticatedGamificationRoute: typeof AuthenticatedGamificationRoute
  AuthenticatedHomeRoute: typeof AuthenticatedHomeRoute
  AuthenticatedIntegrationsRoute: typeof AuthenticatedIntegrationsRouteWithChildren
  AuthenticatedKnowledgeCenterRoute: typeof AuthenticatedKnowledgeCenterRoute
  AuthenticatedMyWorkRoute: typeof AuthenticatedMyWorkRoute
  AuthenticatedNotificationsRoute: typeof AuthenticatedNotificationsRoute
  AuthenticatedParameterManagementRoute: typeof AuthenticatedParameterManagementRoute
  AuthenticatedPartsManagementRoute: typeof AuthenticatedPartsManagementRouteWithChildren
  AuthenticatedPreventiveMaintenanceRoute: typeof AuthenticatedPreventiveMaintenanceRoute
  AuthenticatedProfileRoute: typeof AuthenticatedProfileRoute
  AuthenticatedPurchaseRequestsRoute: typeof AuthenticatedPurchaseRequestsRoute
  AuthenticatedReliabilityRoute: typeof AuthenticatedReliabilityRoute
  AuthenticatedReportsRoute: typeof AuthenticatedReportsRouteWithChildren
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRoute
  AuthenticatedShiftManagementRoute: typeof AuthenticatedShiftManagementRoute
  AuthenticatedSupplierCertificatesRoute: typeof AuthenticatedSupplierCertificatesRoute
  AuthenticatedTeamsRoute: typeof AuthenticatedTeamsRoute
  AuthenticatedTicketsRoute: typeof AuthenticatedTicketsRoute
  AuthenticatedTrainingRoute: typeof AuthenticatedTrainingRoute
  AuthenticatedTrainingManagementRoute: typeof AuthenticatedTrainingManagementRoute
  AuthenticatedUserManagementRoute: typeof AuthenticatedUserManagementRoute
  AuthenticatedUsersRoute: typeof AuthenticatedUsersRoute
  AuthenticatedWorkOrdersRoute: typeof AuthenticatedWorkOrdersRouteWithChildren
  AuthenticatedAssetAssetIdRoute: typeof AuthenticatedAssetAssetIdRoute
  AuthenticatedComplianceAuditLogRoute: typeof AuthenticatedComplianceAuditLogRoute
  AuthenticatedComplianceCertificatesRoute: typeof AuthenticatedComplianceCertificatesRoute
  AuthenticatedComplianceDashboardRoute: typeof AuthenticatedComplianceDashboardRoute
  AuthenticatedComplianceLotoPermitsRoute: typeof AuthenticatedComplianceLotoPermitsRoute
  AuthenticatedComplianceRegulationsRoute: typeof AuthenticatedComplianceRegulationsRoute
  AuthenticatedComplianceSafetyRoute: typeof AuthenticatedComplianceSafetyRoute
  AuthenticatedUserUserIdRoute: typeof AuthenticatedUserUserIdRoute
  AuthenticatedAdminIndexRoute: typeof AuthenticatedAdminIndexRoute
  AuthenticatedComplianceIndexRoute: typeof AuthenticatedComplianceIndexRoute
  AuthenticatedAdminWorkflowsWorkflowIdRoute: typeof AuthenticatedAdminWorkflowsWorkflowIdRoute
  AuthenticatedAdminWorkflowsIndexRoute: typeof AuthenticatedAdminWorkflowsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedAnalyticsRoute: AuthenticatedAnalyticsRouteWithChildren,
  AuthenticatedApiDocsRoute: AuthenticatedApiDocsRoute,
  AuthenticatedAssetManagementRoute: AuthenticatedAssetManagementRoute,
  AuthenticatedAssetStatusEventsRoute: AuthenticatedAssetStatusEventsRoute,
  AuthenticatedAssetStatusesRoute: AuthenticatedAssetStatusesRoute,
  AuthenticatedAssetsRoute: AuthenticatedAssetsRoute,
  AuthenticatedCalibrationManagementRoute:
    AuthenticatedCalibrationManagementRoute,
  AuthenticatedCertificatesRoute: AuthenticatedCertificatesRoute,
  AuthenticatedChecklistManagementRoute:
    AuthenticatedChecklistManagementRouteWithChildren,
  AuthenticatedFilesRoute: AuthenticatedFilesRoute,
  AuthenticatedGamificationRoute: AuthenticatedGamificationRoute,
  AuthenticatedHomeRoute: AuthenticatedHomeRoute,
  AuthenticatedIntegrationsRoute: AuthenticatedIntegrationsRouteWithChildren,
  AuthenticatedKnowledgeCenterRoute: AuthenticatedKnowledgeCenterRoute,
  AuthenticatedMyWorkRoute: AuthenticatedMyWorkRoute,
  AuthenticatedNotificationsRoute: AuthenticatedNotificationsRoute,
  AuthenticatedParameterManagementRoute: AuthenticatedParameterManagementRoute,
  AuthenticatedPartsManagementRoute:
    AuthenticatedPartsManagementRouteWithChildren,
  AuthenticatedPreventiveMaintenanceRoute:
    AuthenticatedPreventiveMaintenanceRoute,
  AuthenticatedProfileRoute: AuthenticatedProfileRoute,
  AuthenticatedPurchaseRequestsRoute: AuthenticatedPurchaseRequestsRoute,
  AuthenticatedReliabilityRoute: AuthenticatedReliabilityRoute,
  AuthenticatedReportsRoute: AuthenticatedReportsRouteWithChildren,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRoute,
  AuthenticatedShiftManagementRoute: AuthenticatedShiftManagementRoute,
  AuthenticatedSupplierCertificatesRoute:
    AuthenticatedSupplierCertificatesRoute,
  AuthenticatedTeamsRoute: AuthenticatedTeamsRoute,
  AuthenticatedTicketsRoute: AuthenticatedTicketsRoute,
  AuthenticatedTrainingRoute: AuthenticatedTrainingRoute,
  AuthenticatedTrainingManagementRoute: AuthenticatedTrainingManagementRoute,
  AuthenticatedUserManagementRoute: AuthenticatedUserManagementRoute,
  AuthenticatedUsersRoute: AuthenticatedUsersRoute,
  AuthenticatedWorkOrdersRoute: AuthenticatedWorkOrdersRouteWithChildren,
  AuthenticatedAssetAssetIdRoute: AuthenticatedAssetAssetIdRoute,
  AuthenticatedComplianceAuditLogRoute: AuthenticatedComplianceAuditLogRoute,
  AuthenticatedComplianceCertificatesRoute:
    AuthenticatedComplianceCertificatesRoute,
  AuthenticatedComplianceDashboardRoute: AuthenticatedComplianceDashboardRoute,
  AuthenticatedComplianceLotoPermitsRoute:
    AuthenticatedComplianceLotoPermitsRoute,
  AuthenticatedComplianceRegulationsRoute:
    AuthenticatedComplianceRegulationsRoute,
  AuthenticatedComplianceSafetyRoute: AuthenticatedComplianceSafetyRoute,
  AuthenticatedUserUserIdRoute: AuthenticatedUserUserIdRoute,
  AuthenticatedAdminIndexRoute: AuthenticatedAdminIndexRoute,
  AuthenticatedComplianceIndexRoute: AuthenticatedComplianceIndexRoute,
  AuthenticatedAdminWorkflowsWorkflowIdRoute:
    AuthenticatedAdminWorkflowsWorkflowIdRoute,
  AuthenticatedAdminWorkflowsIndexRoute: AuthenticatedAdminWorkflowsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  RegisterRoute: RegisterRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
